import React, { useEffect, useState } from 'react'
import AdminHeaderComponent from '../Components/AdminHeaderComponent';
import { getAllTargetRole } from '../Services/AdminService';
import {  targetRoleResponse } from '../Types/AdminType';
import TargateRoleComponent from '../Components/TargateRoleComponent';

function TargateRolePage() {
  const [adminData, setAdminData] = useState<targetRoleResponse []>([]);
      const [loading, setLoading] = useState<boolean>(true);
      const [error, setError] = useState<string>("");
      
      useEffect(() => {
        const fetchCandidate = async () => {
          try {
            setLoading(true); // Ensure loading is true when starting
            const response = await getAllTargetRole();
  
            console.log("Target Roles Response:", response);
      
            if (response.success) {
              setAdminData(response.data);
            } else {
              setError(response.message || "Could not retrieve target role data.");
            }
          } catch (err) {
            setError("An unexpected error occurred while loading the target roles.");
            console.error(err);
          } finally {
            setLoading(false);
          }
        };
      
        fetchCandidate();
      }, []); // Empty dependency array is fine if using localStorage
  
  
      const handleEdit = () => {
        // Implement the logic to edit the recruiter with the given ID and updated data
        console.log(`Edit recruiter with ID:` );
      }
  
      const handleDelete = (id: string) => {
        // Implement the logic to delete the recruiter with the given ID
        console.log(`Delete recruiter with ID: ${id}`);
      }

  return (
    <div>
      {/* <AdminHeaderComponent /> */}
      <TargateRoleComponent
       data={adminData} 
          onEditSubmit={handleEdit} 
          onDeleteConfirm={handleDelete} 
          onRegisterSubmit={handleEdit} 
          menuName="Target Role"/>
    </div>
  )
}

export default TargateRolePage